import { useMemo } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { themeSettings } from "./theme";
import { AuthProvider } from 'contexts/AuthContext';
import { DateRangeProvider } from 'contexts/DateRangeContext';
import NotFound from "components/NotFound";
import LoginPage from "scenes/login";
import Layout from "scenes/layout";
import SubLayout from 'scenes/layout/SubLayout';
import Dashboard from "scenes/dashboard";
import CrewMemberPSW from "scenes/inflightSales/CrewMemberPSW";
import CrewRequests from "scenes/crewRequests";
import CrewRequestEdit from "scenes/crewRequests/CrewRequest";
import Invoices from "scenes/inflightSales/Invoices";
import CrewMemberSales from "scenes/inflightSales/CrewMemberSales";
import RosterDetails from "scenes/rosterDetails";
import Settings from "scenes/settings";
import InflightSales from "scenes/inflight";
import SalesStats from "scenes/inflight/SalesStats";


function App() {
  const token      = useSelector((state) => state.auth.token);
  const offlineMode = useSelector((state) => state.auth.offlineMode);
  const isAuth = Boolean(token) || offlineMode;
  const mode = useSelector((state) => state.auth.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);  
  
  const ProtectedRoute = ({ element }) => (isAuth ? element : <Navigate to="/login" />);

  return (
    <div className="app">
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <AuthProvider>
            <DateRangeProvider>
              <CssBaseline />
              <Toaster
                position="top-center"
                reverseOrder={false}
                toastOptions={{                  
                  style: { transition: "none" },
                }}
              />
              <Routes>
                <Route path="/login" element={<LoginPage />} />

                <Route element={<Layout />}>
                  <Route index path='/' element={<Navigate to='/dashboard' />} />          
                  <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />                  
                  <Route path="/invoices" element={<ProtectedRoute element={<Invoices />} />} />
                  <Route path="/crewsales" element={<ProtectedRoute element={<CrewMemberSales />} />} />
                  <Route path="/rosterdetails" element={<ProtectedRoute element={<RosterDetails />} />} />
                  <Route 
                    path="crewrequests"
                    element={
                      <ProtectedRoute element={<SubLayout />}/>
                    }
                  >
                    <Route index element={<CrewRequests />} />
                    <Route path="new" element={<CrewRequestEdit />} />
                    <Route path=":requestId" element={<CrewRequestEdit />} />
                  </Route>
                  <Route path="/inflight" element={<ProtectedRoute element={<InflightSales />} />} />
                  <Route path="/inflight-stats" element={<ProtectedRoute element={<SalesStats />} />} />
                  <Route path="/changepassword" element={<ProtectedRoute element={<CrewMemberPSW />} />} />
                  <Route path="/settings" element={<ProtectedRoute element={<Settings />} />} />
                </Route>                          

                {/* NotFound */}    
                <Route path="*" element={<NotFound />} />
              </Routes>
            </DateRangeProvider>
          </AuthProvider>      
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
